<template>
    <div class="main-container page-container">
        <div class="search-box gauge_20">
            <div class="input-item-01">
                <span class="star">*</span>
                <span class="label">统计周期</span>
                <div class="cycle">
                    <div
                        class="tab"
                        :class="{ active: item.value == cycleActiveIndex }"
                        @click="clickCycle(item.value)"
                        v-for="item in cycleList"
                        :key="item.value"
                    >
                        <a>{{ item.label }}</a>
                    </div>
                </div>
                <DatePicker
                    :disabled="cycleActiveIndex != 4"
                    style="width: 240px"
                    :clearable="false"
                    type="daterange"
                    split-panels
                    separator="至"
                    placement="bottom"
                    v-model="search.validDate"
                    format="yyyy-MM-dd"
                    placeholder="选择日期"
                    @on-ok="changeDatePicker('DatePicker1')"
                    @on-change="changeDatePicker('DatePicker1')"
                    :options="options"
                    :editable="false"
                    :confirm="true"
                    ref="DatePicker1"
                >
                </DatePicker>
                <span class="tips" v-if="result">* 统计周期区间最长为366天</span>
            </div>
        </div>

        <div class="btn-item config">
            <Button type="primary" @click="$refs.configOrg.open()" v-show="$units.pointAction('dataCenter_1_2_1')">配置机构业绩目标</Button>
        </div>

        <div class="statistics-container">
            <div class="statistics-item">
                <div class="text-name-icon">
                    <span class="total-text">本公司合计</span>
                    <span class="tip-icon">?</span>
                    <div class="pop-tip">
                        <span>包含直属团队、下级机构业绩。</span>
                        <div class="arrow"></div>
                    </div>
                </div>
                <div class="right-line"></div>
            </div>

            <div class="statistics-item">
                <span class="num">{{ statisticsObj.policyNum || 0 }}</span>
                <span>件数</span>
                <div class="right-line"></div>
            </div>

            <div class="statistics-item">
                <span class="num">{{ statisticsObj.fee || 0 }}</span>
                <span>规模保费(元)</span>
                <div class="right-line"></div>
            </div>

            <div class="statistics-item">
                <span class="num">{{ statisticsObj.fyb || 0 }}</span>
                <span>标准保费(元)</span>
                <div class="right-line"></div>
            </div>

            <div class="statistics-item">
                <span class="num">{{ statisticsObj.fybTarget || 0 }}</span>
                <span>周期内标保目标(元)</span>
                <div class="right-line"></div>
            </div>

            <div class="statistics-item">
                <span class="num-percentage" v-if="statisticsObj.finishRate == 0">0%</span>
                <span class="num-percentage" v-else>{{
                    (statisticsObj.finishRate && Number(statisticsObj.finishRate * 100).toFixed(2) + '%') || '-'
                }}</span>
                <span>完成率</span>
            </div>
        </div>

        <loading :isShow="$root.$children[0].isShowLoading" />
        <div class="table-box setTable">
            <Table
                :columns="columns"
                :data="tableData"
                @on-sort-change="tableSortChange"
                :no-data-text="`<img class='no-img' src=${noImgUrl} /><div class='no-data-text'>无下一级机构数据<div>`"
            >
                >
                <template slot-scope="{ row }" slot="finishRate">
                    <div class="finish-rate">
                        <div class="speed" v-if="row.finishRate || row.finishRate == 0">
                            <div class="speed-box" :style="{ width: row.percent }"></div>
                        </div>

                        <span class="num" v-if="row.finishRate">{{ row.percent }}</span>
                        <span v-else-if="row.finishRate == null" class="line">-</span>
                        <span class="num" v-else-if="row.finishRate == 0">0%</span>
                    </div>
                </template>
            </Table>
        </div>
        <config-org-target ref="configOrg" :initData="initData"></config-org-target>
    </div>
</template>

<script>
import filters from '@/api/filter';
import configOrgTarget from './components/configOrgTarget';
import noImgUrl from '@/static/images/no-data.png';

export default {
    name: 'organization',
    components: { configOrgTarget },
    filters,
    data() {
        return {
            noImgUrl,
            total: 0,
            search: {
                queryType: '2', //1 机构业绩 2业务进度
                type: 1, //类型 (1 机构)
                pageNo: 1,
                pageSize: 999
            },
            cycleActiveIndex: 1,
            cycleList: [
                {
                    label: '本月',
                    value: '1'
                },
                {
                    label: '本季',
                    value: '2'
                },
                {
                    label: '本年',
                    value: '3'
                },
                {
                    label: '自定义',
                    value: '4'
                }
            ],
            columns: [
                {
                    title: '序号',
                    align: 'center',
                    width: 80,
                    type: 'index'
                },
                {
                    title: '下级机构名称',
                    key: 'name',
                    minWidth: 200,
                    align: 'center',
                },
                {
                    title: '件数',
                    key: 'policyNum',
                    minWidth: 120,
                    align: 'center',
                    sortable: 'custom',
                    tooltip: true
                },
                {
                    title: '规模保费(元)',
                    key: 'fee',
                    minWidth: 120,
                    align: 'center',
                    sortable: 'custom',
                    tooltip: true
                },
                {
                    title: '标准保费(元)',
                    key: 'fyb',
                    minWidth: 120,
                    align: 'center',
                    sortable: 'custom',
                    tooltip: true,
                    sortType:'desc',
                },
                {
                    title: '周期内标保目标(元)',
                    minWidth: 140,
                    align: 'center',
                    key: 'fybTarget',
                    sortable: 'custom'
                },
                {
                    title: '完成率',
                    minWidth: 120,
                    sortable: 'custom',
                    key: 'finishRate',
                    align: 'center',
                    slot: 'finishRate'
                }
            ],
            tableData: [],
            statisticsObj: {},
            options: {
                disabledDate: date => {
                    return date.getTime() > new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
                }
            },
            result: false
        };
    },
    created() {
        this.setDatePeriod();
        this.initData();
    },
    mounted() {
        this.$nextTick(()=>{
            document.querySelectorAll('.ivu-btn-default')[0].style = 'display:none; !important';
            document.querySelectorAll('.ivu-btn-default')[1].style = 'display:none; !important';
            document.querySelectorAll('.ivu-btn-default')[2].style = 'display:none; !important';
        })
    },
    methods: {
        setDatePeriod() {
            var monthStart = '';
            var monthEnd = filters.filterTime(new Date(), 'YYYY-MM-DD');
            if (this.cycleActiveIndex == 1) {
                // 设置本月时间
                monthStart = filters.filterTime(
                    new Date(new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(0, 0, 0)),
                    'YYYY-MM-DD'
                );
                // monthEnd = filters.filterTime(new Date(new Date(new Date().getFullYear(), new Date().getMonth()+ 1, 0).setHours(23, 59, 59, 59)), 'YYYY-MM-DD');
            } else if (this.cycleActiveIndex == 2) {
                //本季
                monthStart = filters.getQuater('s', 0);
                // let monthEnd = filters.getQuater('e', 0);
            } else if (this.cycleActiveIndex == 3) {
                //本年
                monthStart = filters.filterTime(new Date(new Date().getFullYear(), 0, 1), 'YYYY-MM-DD');
                // monthEnd = filters.filterTime(new Date(new Date(new Date().getFullYear() + 1, 0, 0).setHours(23, 59, 59, 59)), 'YYYY-MM-DD');
            }
            this.search.validDate = [monthStart, monthEnd];
        },

        setRequestParam() {
            let obj = JSON.parse(JSON.stringify(this.search));
            if (obj.validDate && obj.validDate[0]) {
                obj.startDate = filters.filterTime(obj.validDate[0], 'YYYY-MM-DD');
                obj.endDate = filters.filterTime(obj.validDate[1], 'YYYY-MM-DD');
            }
            if (this.cycleActiveIndex != 4) {
                delete obj.startDate;
                delete obj.endDate;
            }
            obj.searchType = this.cycleActiveIndex;
            delete obj.validDate;
            let { ...params } = obj;
            return params;
        },

        // 计算时间日期
        dateCalc(num = 1, date = false) {
            if (!date) {
                date = new Date(); //没有传入值时,默认是当前日期
                date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
            }
            date += ' 00:00:00'; //设置为当天凌晨12点
            date = Date.parse(new Date(date)) / 1000; //转换为时间戳
            date += 86400 * num; //修改后的时间戳
            var newDate = new Date(parseInt(date) * 1000); //转换为时间
            return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
        },

        // 列表
        initList() {
            this.$root.$children[0].isShowLoading = true;
            this.$http({
                url: '/buz/dataCenter/queryStatisticsList',
                type: 'PUT',
                data: this.setRequestParam(),
                apiPermissionCode:'dataCenter_1_1_0'
            })
                .then(res => {
                    this.total = res.total;
                    this.tableData = res.data.map(item => {
                        return {
                            ...item,
                            percent: Number(item.finishRate * 100).toFixed(2) + '%'
                        };
                    })
                })
                .finally(() => {
                    this.$root.$children[0].isShowLoading = false;
                });
        },

        // 统计
        initStatistics() {
            this.$http({
                url: '/buz/dataCenter/queryStatistics',
                type: 'PUT',
                data: this.setRequestParam()
            }).then(res => {
                this.statisticsObj = res.data;
            });
        },

        initData() {
            let maxDays = filters.getDiffDay(this.search.validDate[1], this.search.validDate[0]);
            if (maxDays > 366 && this.cycleActiveIndex==4) {
                this.$Message.error('统计周期区间最长为366天');
                this.result = true;
                return
            }
            this.result = false;

            this.initList();
            this.initStatistics();
        },

        // 选中日期
        changeDatePicker(key) {
            let maxDays = filters.getDiffDay(this.search.validDate[1], this.search.validDate[0]);
            if (maxDays > 366 && this.cycleActiveIndex==4) {
                this.$Message.error('统计周期区间最长为366天');
                this.$refs[key].visible = true;
                this.result = true;
                return
            }
            this.result = false;
            this.initData();
        },

        // 根据字段排序
        tableSortChange(column) {
            if (column.order == 'asc') {
                delete this.search.descs;
                this.search.ascs = column.key;
            } else if (column.order == 'desc') {
                delete this.search.ascs;
                this.search.descs = column.key;
            } else if (column.order == 'normal') {
                delete this.search.ascs;
                delete this.search.descs;
            }
            this.initData();
        },

        // 统计周期切换
        clickCycle(value) {
            this.cycleActiveIndex = value;
            if (value != 4) {
                this.initData();
                this.setDatePeriod();
            }
            this.result = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.input-item-01 {
    position: relative;
    display: flex;
    align-items: center;
    min-width: 680px;
    height: 32px;
    .star {
        color: #ed4014;
        margin-right: 4px;
        margin-top: 2px;
    }
    .label {
        margin-right: 10px;
    }
    .tips {
        color: #ed4014;
        position: absolute;
        bottom: -19px;
        right: 100px;
        font-size: 14px;
    }
}

.cycle {
    display: flex;
    .tab {
        margin-right: 10px;
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #e3e5e8;
        border-radius: 2px;
        a {
            display: block;
            font-size: 13px;
            color: #515c6f;
        }
        &.active {
            background: #f4f7ff;
            border: 1px solid #236dff;
            a {
                color: #236dff;
            }
        }
    }
}

.config {
    position: absolute;
    right: 20px;
    top: 10px;
}

.statistics-container {
    margin-top: 20px;
    height: 70px;
    width: 100%;
    background: #f7f7f7;
    display: flex;
    align-items: center;
    .statistics-item {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: relative;
        .num {
            font-size: 16px;
            color: #3c464f;
            font-weight: bold;
        }
        .num-percentage {
            font-size: 16px;
            color: #ff5f00;
            font-weight: bold;
        }
        span {
            color: #515c6f;
            font-size: 13px;
        }
        .total-text {
            font-weight: bold;
            color: #515c6f;
            font-size: 13px;
        }
        .right-line {
            position: absolute;
            right: 0;
            top: 50%;
            margin-top: -10px;
            width: 1px;
            height: 20px;
            background: #dddddd;
        }

        .text-name-icon {
            .tip-icon {
                
                margin-left: 6px;
                width: 15px;
                height: 15px;
                border-radius: 15px;
                background: transparent;
                border: 1px solid rgb(185, 184, 184);
                color: rgb(189, 187, 187);
                display: inline-block;
                text-align: center;
                line-height: 14px;
                font-size: 14px;
                cursor: pointer;
                top: 50%;
            }
            .tip-icon:hover + .pop-tip {
                opacity: 0.9;
                z-index: 1;
                display: block;
            }
            .pop-tip {
                position: absolute;
                top: 50px;
                left: 100px;
                width: 248px;
                padding: 7px 10px;
                display: flex;
                justify-content: center;
                flex-direction: column;
                background-color: #444444;
                display: none;
                border-radius: 4px;
                span {
                    font-size: 12px;
                    font-weight: 500;
                    color: #fff;
                }
                .arrow {
                    position: absolute;
                    width: 12px;
                    height: 12px;
                    background-color: #444444;
                    opacity: 0.9;
                    top: -4px;
                    left: 50%;
                    margin-left: -6px;
                    transform: rotateZ(135deg);
                }
            }
        }
    }
}
.table-box {
    margin-top: 15px;
    .finish-rate {
        display: flex;
        align-items: center;
        justify-content: center;
        .speed {
            margin-left: 35px;
            width: 50px;
            height: 12px;
            background: #EAEAEA;
            overflow: hidden;
            .speed-box {
                height: 100%;
                background: #55bc41;
            }
        }
        .num {
            display: block;
            color: #ff5f00;
            width: 100px;
            text-align: left;
            padding-left: 10px;
        }
        .line {
            width: 100%;
            text-align: center;
        }
    }
    /deep/.no-img {
        width: 270px;
        height: 146px;
        margin-top: 60px;
        margin-bottom: 10px;
    }
    /deep/.no-data-text {
        font-size: 14px;
        color: #a8adb7;
        margin-bottom: 30px;
    }
}
</style>
